import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { map, Observable } from 'rxjs';
import { PowerBiSettings } from '@api/models/powerbi.model';
import { ShowResponse } from '@api/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class PowerBiSettingsService {
  private http = inject(HttpClient);

  getSettings(municipalityId: string): Observable<PowerBiSettings> {
    return this.http
      .get<ShowResponse<PowerBiSettings> | PowerBiSettings>(
        `${environment.apiUrl}/municipalities/${municipalityId}/powerbi-settings`
      )
      .pipe(map((response) => this.unwrapSettings(response)));
  }

  updateSettings(
    municipalityId: string,
    rls_role: string
  ): Observable<PowerBiSettings> {
    return this.http
      .put<ShowResponse<PowerBiSettings> | PowerBiSettings>(
        `${environment.apiUrl}/municipalities/${municipalityId}/powerbi-settings`,
        { rls_role }
      )
      .pipe(map((response) => this.unwrapSettings(response)));
  }

  /** API kan `{ data: ... }` of een plat object teruggeven. */
  private unwrapSettings(
    response: ShowResponse<PowerBiSettings> | PowerBiSettings
  ): PowerBiSettings {
    if (
      response &&
      typeof response === 'object' &&
      'data' in response &&
      response.data != null
    ) {
      return response.data;
    }
    return response as PowerBiSettings;
  }
}
